import { action } from '@ember/object';
import Component from '@glimmer/component';

export interface Args {
	id: string;
	name: string;
	value: AnySimpleValue;
	selected: AnySimpleValue;
	onChange: (newSelected: AnySimpleValue) => void;
	isDisabled?: boolean;
}

interface FormRadiobuttonSingleComponentInterface<T> {
	Element: HTMLInputElement; // this is needed for ...attributes
	Args: T;
}

export default class FormRadiobuttonSingleComponent extends Component<
	FormRadiobuttonSingleComponentInterface<Args>
> {
	get isChecked() {
		return (
			this.args.value === this.args.selected ||
			(typeof this.args.value !== 'number' && !this.args.value && !this.args.selected)
		); // undefined === '' etc
	}

	@action
	onChange() {
		// can only select on click (no deselect for radiobuttons)
		this.args.onChange(this.args.value);
	}

	<template>
		<input
			...attributes
			type="radio"
			id={{@id}}
			name={{@name}}
			value={{@value}}
			disabled={{@isDisabled}}
			checked={{this.isChecked}}
			{{! @glint-expect-error: it's probably fine :P }}
			onchange={{this.onChange}}
		/>
	</template>
}
